/* eslint-disable no-param-reassign */
import Vue from 'vue';
import moment from 'moment';

export default {
  mount(vue, store) {
    vue.$config = {
      api: process.env.VUE_APP_API,
      map: {
        deviceHistoryCount: 5,
        deviceLagDelay: 2 * 60 * 1000,
        deviceTimeoutDelay: 10 * 60 * 1000,
      },
    };

    vue.$api.defaults.baseURL = vue.$config.api;

    moment.locale('fr-ch');

    // user à priori connecté, on check
    return store.dispatch('auth/loadUser')
      .then(() => store.dispatch('preferences/fetch'))
      // le token n'est plus valable, on déconnecte la personne
      .catch(() => store.commit('auth/logout'))
      .then(() => Vue.prototype.$config);
  },
};
